import {useState} from "react";
import {Button} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {buildExportUrl, downloadExport} from "./exportHelpers";

type GenerateButtonsProps = {
    resourceId: string;
    collectionId?: string;
    className?: string;
};

export const GenerateButtons = ({
    resourceId,
    collectionId,
    className,
}: GenerateButtonsProps) => {
    const {t} = useTranslation();
    const [isDownloading, setIsDownloading] = useState(false);

    if (!collectionId) return null;

    const handleGenerate = async () => {
        setIsDownloading(true);
        try {
            const url = buildExportUrl({
                format: "docx",
                resourceId,
                collectionId,
                topicIds: [resourceId],
            });
            await downloadExport(url);
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <Button
            className={className}
            variant="light"
            size="compact-sm"
            loading={isDownloading}
            onClick={handleGenerate}
        >
            {t("Word.Generate")}
        </Button>
    );
};
